import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ModalRename = ({ open, handelClose, data }) => {
    const { t } = useTranslation(['metadata']);
    const [form] = Form.useForm();
    const [loading] = useState(false);
    const onFinish = async (e) => {
        console.log(e);
    };
    useEffect(() => {
        form.setFieldValue('name', data?.name);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Modal
            centered
            width={500}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div>
                <div className="text-1xl text-center">{t('Rename')}</div>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        className="my-10"
                        name="name"
                        label={t('Name Group')}
                        rules={[
                            {
                                required: true,
                                message: t('requiredField'),
                            },
                        ]}
                    >
                        <Input size="large" placeholder={t('Name')} />
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4">
                        <Button
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                            className="min-w-[150px]"
                        >
                            {t('Cancel')}
                        </Button>

                        <Button
                            loading={loading}
                            // onClick={handelOk}
                            size="large"
                            type="primary"
                            htmlType="submit"
                            className="min-w-[150px]"
                        >
                            {t('Submit')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};
export default ModalRename;
